export default __webpack_public_path__ + "static/media/preloader.132da723.gif";